import RfiCreateTemplate from './RfiCreateTemplate.page';

export default RfiCreateTemplate;
